<div
	[ngClass]="{
		'bg-success border-success': toast.type === 'success',
		'bg-warning border-warning': toast.type === 'warning',
		'bg-danger border-danger': toast.type === 'error',
		'bg-action border-action': toast.type === 'info',
		'animate-slide-up': !toast.removing,
		'animate-fade-out': toast.removing,
	}"
	class="flex relative items-center p-3 rounded-lg shadow-lg text-white font-medium min-w-[350px] border"
>
	<span class="flex items-center justify-center w-5 h-5 rounded-full bg-white/20 mr-3 font-bold toast-icon">
		<ng-container [ngSwitch]="toast.type">
			<div *ngSwitchCase="'success'" class="flex justify-center items-center">
				<app-keenicon name="check" type="solid" class="text-white"></app-keenicon>
			</div>
			<span *ngSwitchCase="'warning'" class="flex justify-center items-center">
				<app-keenicon name="abstract-22" type="solid" class="text-white"></app-keenicon>
			</span>
			<span *ngSwitchCase="'error'" class="flex justify-center items-center">
				<app-keenicon name="abstract-11" type="solid" class="text-white"></app-keenicon>
			</span>
			<span *ngSwitchCase="'info'" class="flex justify-center items-center">
				<app-keenicon name="information-5" type="outline" class="text-white"></app-keenicon>
			</span>
		</ng-container>
	</span>
	<span translate class="flex-1 leading-tight text-sm">{{ toast.message || '' | translate }}</span>
	<button
		*ngIf="toast.closeButton"
		class="bg-transparent border-none text-inherit text-lg cursor-pointer p-0 ml-3 w-5 h-5 flex items-center justify-center rounded-full transition hover:bg-white/20"
		(click)="onClose()"
		aria-label="Close"
	>
		&times;
	</button>
</div>
